import apiClient from './client';

// ─── Typen ──────────────────────────────────────────────────────────────────

export interface SourceOverviewTotals {
  /** Personen im aktiven Baum insgesamt. */
  persons: number;
  /** Personen mit mindestens einem substanziellen Fakt (kein reiner Namens-Stub). */
  personsWithData: number;
  /** Davon mit mindestens einer Quelle belegt. */
  personsSourced: number;
  /** Dokumentiert, aber unbelegt (= Länge der vollständigen Arbeitsliste). */
  personsUnsourcedWithData: number;
  /** Quell-Datensätze im Baum insgesamt. */
  sources: number;
  /** Anteil belegter Personen an den dokumentierten (0..1). */
  coverage: number;
}

export interface SourceWorklistEntry {
  id: string;
  firstName: string;
  lastName: string | null;
  birthName: string | null;
  birthDateText: string | null;
  deathDateText: string | null;
  /** Anzahl belegbarer Fakten (Geburt/Tod/Ort/Beruf) – höher = dringlicher. */
  factCount: number;
}

export interface SourceOverview {
  totals: SourceOverviewTotals;
  worklist: SourceWorklistEntry[];
  /** Wurde die Arbeitsliste gekürzt (mehr Einträge als übertragen)? */
  worklistTruncated: boolean;
}

// ─── API ────────────────────────────────────────────────────────────────────

export async function getSourceOverview(): Promise<SourceOverview> {
  const { data } = await apiClient.get<SourceOverview>('/sources/overview');
  return data;
}
